import React, { PropsWithChildren } from 'react'

export function getProviderWrapper(
  Provider: React.ComponentType<PropsWithChildren>
) {
  return function wrapper(WrappedComponent) {
    return function ProviderWrapper(props) {
      return (
        <Provider>
          <WrappedComponent {...props} />
        </Provider>
      )
    }
  }
}

interface RootScope {
  readonly rootScope: {
    readonly $on: (eventName: string, callback: any) => void
  }
}

export function getProviderWrapperWithRootScope<P extends RootScope>(
  Provider: React.ComponentType<PropsWithChildren<RootScope>>
) {
  return function wrapper(WrappedComponent) {
    return function ProviderWrapper(props: P) {
      return (
        <Provider rootScope={props.rootScope}>
          <WrappedComponent {...props} />
        </Provider>
      )
    }
  }
}
